/**
 * 48 コマ系の画面で共有する、コマ値の上限とエラー表示の件数。
 * 供給力 48 点データ (AC-S4D-047) と需要想定 (AC-DFC-EDIT-004) が同じ根拠を使う。
 */

/**
 * 保存単位 (kWh/30min) のコマ値上限。
 *
 * OCCTO 提出値の桁数上限 (9 桁 = 999,999,999、公式 XSD の数量型 I9) に合わせる。
 * backend の `entity.QuantityI9Max` と値を揃えること。
 */
export const MAX_STORED_SLOT_VALUE = 999_999_999

/** エラー表示に並べる最大件数 (超過分は「ほか N 件」に畳む) */
export const MAX_SHOWN_REJECTIONS = 3
